import React from 'react';

// Professional brand logo SVG components - simplified, recognizable shapes
export const MercedesLogo = ({ className = "w-10 h-10 text-white" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="currentColor">
    <circle cx="50" cy="50" r="48" fill="none" stroke="currentColor" strokeWidth="3"/>
    <path d="M50 6 L50 50 L88 72 L50 50 L12 72 L50 50 L50 6 Z" stroke="currentColor" strokeWidth="3" fill="none"/>
  </svg>
);

export const BmwLogo = ({ className = "w-10 h-10 text-white" }) => (
  <svg viewBox="0 0 100 100" className={className}>
    <circle cx="50" cy="50" r="48" fill="none" stroke="currentColor" strokeWidth="3"/>
    <circle cx="50" cy="50" r="36" fill="none" stroke="currentColor" strokeWidth="2"/>
    <path d="M50 14 L50 50 L86 50 Z" fill="currentColor" opacity="0.9"/>
    <path d="M50 86 L50 50 L14 50 Z" fill="currentColor" opacity="0.9"/>
  </svg>
);

export const AudiLogo = ({ className = "w-16 h-10 text-white" }) => (
  <svg viewBox="0 0 200 60" className={className} fill="none" stroke="currentColor" strokeWidth="3">
    <circle cx="30" cy="30" r="25"/>
    <circle cx="70" cy="30" r="25"/>
    <circle cx="110" cy="30" r="25"/>
    <circle cx="150" cy="30" r="25"/>
  </svg>
);

export const VolkswagenLogo = ({ className = "w-10 h-10 text-white" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" strokeWidth="3">
    <circle cx="50" cy="50" r="48"/>
    <path d="M30 30 L42 70 L50 50 L58 70 L70 30 M40 30 L50 70 L60 30" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const MiniLogo = ({ className = "w-14 h-10 text-white" }) => (
  <svg viewBox="0 0 140 60" className={className}>
    <ellipse cx="70" cy="30" rx="60" ry="22" fill="none" stroke="currentColor" strokeWidth="2"/>
    <text x="70" y="38" textAnchor="middle" fill="currentColor" fontSize="16" fontWeight="bold" fontFamily="sans-serif">MINI</text>
  </svg>
);

export const ToyotaLogo = ({ className = "w-12 h-10 text-white" }) => (
  <svg viewBox="0 0 120 80" className={className} fill="none" stroke="currentColor" strokeWidth="3">
    <ellipse cx="60" cy="40" rx="55" ry="35"/>
    <ellipse cx="60" cy="40" rx="20" ry="35"/>
    <ellipse cx="60" cy="40" rx="38" ry="13"/>
  </svg>
);

export const LexusLogo = ({ className = "w-14 h-10 text-white" }) => (
  <svg viewBox="0 0 140 60" className={className} fill="none" stroke="currentColor" strokeWidth="2">
    <ellipse cx="70" cy="30" rx="60" ry="22"/>
    <text x="70" y="36" textAnchor="middle" fill="currentColor" fontSize="14" fontWeight="bold" fontFamily="serif" letterSpacing="2">LEXUS</text>
  </svg>
);

export const HondaLogo = ({ className = "w-10 h-10 text-white" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" strokeWidth="3">
    <path d="M20 25 L20 75 M20 50 L80 50 M80 25 L80 75"/>
  </svg>
);

export const NissanLogo = ({ className = "w-12 h-10 text-white" }) => (
  <svg viewBox="0 0 120 60" className={className} fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="60" cy="30" r="25"/>
    <rect x="20" y="25" width="80" height="10" fill="currentColor" stroke="none"/>
    <text x="60" y="34" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold" fontFamily="sans-serif">NISSAN</text>
  </svg>
);

export const MazdaLogo = ({ className = "w-10 h-10 text-white" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" strokeWidth="2.5">
    <ellipse cx="50" cy="50" rx="45" ry="30"/>
    <path d="M30 35 Q50 25 70 35 Q60 50 70 65 Q50 75 30 65 Q40 50 30 35 Z"/>
  </svg>
);
